var forgotPassword = {
    validation: function () {
        $('#form-forgot-password').validate({
            errorClass: '-error',
            errorElement: 'span',
            rules: {
                "data[User][email]": {
                    required: true,
                    email: true,
                    remote: {
                        url: "/users/verifyEmailExists",
                        type: "POST",
                        data: { forgotPass: true },
                    }
                },
            },
            messages: {
                "data[User][email]": {
                    required: 'Insira um e-mail',
                    email: 'Insira um e-mail válido',
                    remote: 'Insira um e-mail que esteja registrado.'
                }
            }
        });
    },

    sendRedefineEmail: function () {
        if ($('#form-forgot-password').valid()) {
            $.ajax({
                url: '/users/generateToken',
                type: 'POST',
                data: { email: $('[data-email]').val() },
                beforeSend: function () {
                    $('[data-forgot-password]').attr('disabled', true);
                    $('[data-forgot-password]').css('cursor', 'progress');
                }
            }).done(function (response) {
                $('[data-forgot-password]').removeAttr('style');
                $('[data-forgot-password]').attr('disabled', false)
                window.location.reload();
            })
        }
    },

    ready: function () {
        forgotPassword.validation();
        $('[data-forgot-password]').click(forgotPassword.sendRedefineEmail);
    }
};

$(document).ready(forgotPassword.ready);